import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { Enterprise } from '../interfaces/enterprise';

interface EnterpriseState {
  enterprise: Enterprise | null;
  update: (enterprise: Enterprise | null) => void;
  updateEnterprise: (enterprise: Enterprise | null) => void;
  loaded: boolean;
  reset: () => void; // Add reset function
}

export const useEnterpriseStore = create<EnterpriseState>()(
  devtools(
    persist(
      (set) => ({
        enterprise: null,
        loaded: false,
        update: (enterprise) => set(() => ({ enterprise: enterprise })), //set((state)
        updateEnterprise: (enterprise) =>
          set(() => {
            return { enterprise: enterprise, loaded: true };
          }),
        reset: () => set(() => ({ enterprise: null, loaded: false })),
      }),
      {
        name: 'enterprise-storage',
      }
    )
  )
);
